export default "__VITE_ASSET__CggEIgrX__"